export default __webpack_public_path__ + "static/media/physics.59229a2c.png";